import { sanitizeText } from "@/utils/helper"
import { useTranslation } from "next-i18next"

const useFindashowroomi18n = dataProps => {
  const { t } = useTranslation()
  const i18n = {
    backToTop: t("kf.plp.label.backToTop"),
    readArticleText: t("kf.plp.label.readArticle"),
    loadMore: t("kf.plp.label.loadMore"),
    view: t("kf.plp.label.view"),
    all: t("kf.plp.label.all"),
    items: t("kf.plp.label.items"),
    mostPopular: t("kf.plp.label.mostPopular"),
    userMyLocation: dataProps?.userMyLocation
      ? dataProps?.userMyLocation
      : t("kf.findstore.label.userMyLocation"),
    kohlerStores: dataProps?.kohlerStores
      ? dataProps?.kohlerStores
      : t("kf.findstore.label.kohlerStores"),
    showrooms: t("kf.findstore.label.showrooms"),
    kohlerStore: t("kf.findstore.label.kohlerStore"),
    annsacksShowroom: dataProps?.annsacksShowroom
      ? dataProps?.annsacksShowroom
      : t("kf.findstore.label.annsacksShowroom"),
    ctaLink: dataProps?.ctaLink ? dataProps?.ctaLink : "",
    ctaLabel: dataProps?.ctaLabel
      ? dataProps?.ctaLabel
      : t("kf.findstore.label.browseAllStore"),
    isNewTab: dataProps?.isNewTab,
    partsDealer: t("kf.findstore.label.partsDealer"),
    homeCenter: dataProps?.homeCenter
      ? dataProps?.homeCenter
      : t("kf.findStore.label.homeCenter"),
    genuinePartsDealers: dataProps?.tabTitleTab3
      ? dataProps?.tabTitleTab3
      : t("kf.findstore.label.genuinePartsDealers"),
    kohler: t("kf.findStoreUtilNav.label.kohler"),
    annSacks: dataProps?.annSacks
      ? dataProps?.annSacks
      : t("kf.findstore.label.annSacks"),
    annSacksText: dataProps?.annSacksText
      ? dataProps?.annSacksText
      : t("kf.findstore.label.annSacksText"),
    countryPlaceholder: dataProps?.searchPlaceholder
      ? dataProps?.searchPlaceholder
      : t("kf.findstore.label.countryPlaceholder"),
    locationErrormessage: dataProps?.subCopy
      ? sanitizeText(dataProps?.subCopy)
      : t("kf.findstore.label.locationErrormessage"),
    clearAll: t("kf.plp.label.clearAll"),
    viewList: dataProps?.viewList
      ? dataProps?.viewList
      : t("kf.findstore.label.viewList"),
    viewMap: dataProps?.viewMap
      ? dataProps?.viewMap
      : t("kf.findstore.label.viewMap"),
    applyFilters: dataProps?.applyFilters
      ? dataProps?.applyFilters
      : t("kf.findstore.label.applyFilters"),
    filters: t("kf.plp.label.filters"),
    filterSort: t("kf.plp.label.filterSort"),
    viewStoreDetail: t("kf.findStoreUtilNav.label.viewStoreDetail"),
    storeDetail: t("kf.findStoreUtilNav.label.storeDetail"),
    viewShowroomDetails: t("kf.findStoreUtilNav.label.viewShowroomDetails"),
    miles: dataProps?.miles ? dataProps?.miles : t("kf.findstore.label.miles"),
    away: dataProps?.away ? dataProps?.away : t("kf.findstore.label.away"),
    browseAllStore: dataProps?.browseAllStore
      ? dataProps?.browseAllStore
      : t("kf.findstore.label.browseAllStore"),
    setAsMyStore:
      dataProps?.preferredStoreLabel ||
      t("kf.findStoreUtilNav.label.setAsMystore"),
    setAsMyShowroom: t("kf.findStoreUtilNav.label.setAsMyShowroom"),
    home: dataProps?.home ? dataProps?.home : t("kf.findstore.label.home"),
    findStore: dataProps?.findstore
      ? dataProps?.findstore
      : t("kf.findstore.label.findstore"),
    kohlerStoreImgAlt: t("kf.findstore.label.kohlerStoreImgAlt"),
    annsacksShowroomImgAlt: t("kf.findstore.label.annsacksShowroomImgAlt"),
    viewResults: t("kf.plp.label.viewResults"),
    view: t("kf.plp.label.view"),
    results: t("kf.plp.label.results"),
    filterImgAlt: t("kf.findstore.label.filterImgAlt"),
    myStore:
      dataProps?.preferredStoreLabel || t("kf.findStoreUtilNav.label.myStore"),
    retailStore: dataProps?.retailStore
      ? dataProps?.retailStore
      : t("kf.findstore.label.retailStore"),
    retailMobileText: t("kf.findstore.label.retailMobileText"),
    MessageZipcode: t("kf.findStoreUtilNav.MessageZipcode"),
    messageTitleZipcode: t("kf.findStoreUtilNav.messageTitleZipcode"),
    continue: t("kf.checkout.label.continue"),
    expanded: t("kf.productTab.aria.expanded"),
    collapsed: t("kf.productTab.aria.collapsed"),
    ariaLabel: {
      enterZipcode: t("kf.findStoreUtilNav.aria.label.enterZipCode"),
      showFilter: t("kf.findstore.aria.label.showFilter"),
      hideFilter: t("kf.findstore.aria.label.hideFilter"),
      browseAll: t("kf.findstore.aria.label.browseAll"),
      contact: phone => t("kf.findStore.aria.label.contact", { phone }),
      mapMarker: t("kf.findstore.aria.label.mapMarker"),
      mapGuidelines: t("kf.findstore.aria.label.mapGuidelines"),
      currentPage: t("kf.pdp.label.aria.currentPage"),
      page: t("kf.pdp.label.aria.page"),
    },
    filterTitle: (facetName, facetCount) =>
      t("kf.plp.ariaLabel.filterTitle", {
        facetName: facetName,
        facetCount: facetCount,
      }),
  }

  return i18n
}

export default useFindashowroomi18n
